import _ from "lodash";

export default {
  methods: {
    performCompanySearch: _.debounce(
      (search, groupId, loading, onResult, vm) => {
        loading(true);
        vm.suggestCompany({ search, groupId })
          .then(onResult)
          .finally(() => (loading(false), vm.$nextTick() /* sync point */));
      },
      350
    )
  }
};
